import ComplianceStrip from "../components/ComplianceStrip";
import Seo from "../components/Seo";
import GuideMeta from "../components/GuideMeta";
import { PAGES } from "../content/site";

const About = () => {
  const meta = PAGES["/about"];
  return (
    <div className="mp-container py-14 max-w-3xl">
      <Seo title={meta.title} description={meta.description} path="/about" />
      <div className="text-xs uppercase tracking-widest text-[#0F766E]">About</div>
      <h1 className="font-sora mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0B1220]">{meta.h1}</h1>
      <p className="mt-4 text-[#475569] leading-relaxed text-base sm:text-lg">{meta.intro}</p>
      <GuideMeta lastReviewed="August 2026" readTime="3 min read" />
      <div className="mt-8 space-y-6" data-testid="about-sections">
        {meta.sections.map((s) => (
          <div key={s.h} className="mp-card p-6 sm:p-7">
            <h2 className="font-sora text-xl sm:text-2xl font-semibold text-[#0B1220]">{s.h}</h2>
            {s.paragraphs?.map((p) => (
              <p key={p.slice(0, 40)} className="mt-3 text-[#475569] leading-relaxed">{p}</p>
            ))}
            {s.bullets && (
              <ul className="mt-3 space-y-2 text-[15px] text-[#475569]">
                {s.bullets.map((b) => (
                  <li key={b.slice(0, 40)} className="flex gap-2.5">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#10B981] shrink-0" aria-hidden="true" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      <div className="mt-8"><ComplianceStrip /></div>
    </div>
  );
};

export default About;
